/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'delete': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M33.5 14H28v-2c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2h-5.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h19c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5zm-11.458 0H22v-2h4v2h-3.958zM32.294 17H15.5c-.39 0-.5.176-.5.5v18.174s.11.326.5.326h16.794c.39 0 .706-.176.706-.5V17.413c0-.324-.316-.413-.706-.413zM20 32.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v12zm5 0c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-12c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v12zm5 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v12z"/><path pid="1" d="M20 32.5c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-12c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v12zm5 0c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-12c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v12zm5 0c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-12c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v12z" opacity=".3"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/delete.js